export default function TabsControl($location, $rootScope) {
  'ngInject';

  class Tabs {
    constructor(tabs, defaultTab) {
      Object.assign(this, { tabs, defaultTab });
      this.setFromParams();

      this.destroy = $rootScope.$on('$locationChangeSuccess', () => {
        this.setFromParams();
      });
    }

    setFromParams() {
      const initialActiveTab = $location.search().tab || this.defaultTab;
      let activeTabIndex = this.tabs.findIndex(
        (tab) => tab.value === initialActiveTab && !tab.disabled && (!tab.show || tab.show())
      );

      if (activeTabIndex < 0) {
        activeTabIndex = this.tabs.findIndex((tab) => (!tab.show || tab.show()) && !tab.disabled);

        if (activeTabIndex < 0) {
          throw new Error('Cannot determine default tab');
        }
      }

      this.activeTab = this.tabs[activeTabIndex];

      if ($location.search().tab !== this.activeTab.value) {
        $location.search({ tab: this.activeTab.value });
      }
    }

    changeTab(tab, clearHash) {
      if (tab.disabled) {
        return;
      }

      this.activeTab = tab;
      $location.search({ tab: this.activeTab.value });

      if (clearHash) {
        $location.hash(null);
      }
    }
  }

  return Tabs;
}
